module.exports = __webpack_public_path__ + "static/media/face-unsure.1c8b6f9d.svg";